module.exports = __webpack_public_path__ + "static/media/Latin-Merriweather-Regular.73c28f4e.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/merriweather/Latin-Merriweather-Regular.woff
// module id = 516
// module chunks = 0